/**
 * Retourne les IDs média d'une question d'inspection (multi-photos ou fallback media_id).
 *
 * @param {object} question
 * @returns {number[]}
 */
export function getQuestionMediaIds(question) {
    if (question.media_ids?.length) {
        return question.media_ids.map(Number);
    }

    if (question.media_id > 0) {
        return [Number(question.media_id)];
    }

    return [];
}

export function getInspectionMediaUrl(extranetUrl, vehicleId, mediaId) {
    return `${extranetUrl}/vehicules/${vehicleId}/inspections/${mediaId}`;
}
